const CMSTagsServices = (instance) => {

    const getTags = () => instance.get('tags/');

    return {
        getTags
    };
};
export default CMSTagsServices;